var trackError = require('trackError')
var Scope = require('../utils/scope')
var absoluteRouteUrl = require('../utils/absolute-route-url')
var getLanguageFromLocale = require('../utils/get-language-from-locale')

module.exports = Em.Object.extend({
    auth: Ember.inject.service(),

    isLoaded: false,

    data: null,

    api: Em.inject.service(),

    user: function() {
        return this.container.lookup('controller:user').get('model')
    }.property(),

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization'),

    bankConnection: false,

    isLoadingBankConnection: true,

    /* keeping only new bank integration */
    /* because it is only used to load all connection for displaying the yellow error bar alert */
    /* the rest of ember flow using this.bankConnection, which is updated from React */
    load: function() {
        var self = this
        this.set('isLoaded', false)
        var organization = this.get('organization')
        var url = '/banking/' + organization.get('id') + '/accounts'

        if (this.get('isBankSyncReadAuthorized')) {
            this._loadPromise = this.get('api').request('GET', url)
                .then(function(response) {
                    var connections = response

                    var bankConnections = connections
                        .map(function(c) {
                            c.isConnected = true

                            return c
                        })

                    self.set('data', bankConnections)
                    self.set('isLoaded', true)
                    self._loadPromise = null
                    return bankConnections
                })
            return this._loadPromise
        }
    },

    ensureLoaded: function() {
        if (this.get('isLoaded')) {
            return Em.RSVP.resolve(this.get('data'))
        }
        // there is somehow an edge case during signup process,
        // where just "this._loadPromise || this.load()" part returns undefined
        return this._loadPromise || this.load() || Em.RSVP.resolve([])
    },

    isBankSyncReadAuthorized: function() {
        return this.get('auth').isAuthorized(Scope.BankSyncRead)
    }.property(),

    /* empty bank lines view setup button click */
    setup: function(account) {
        var locale = this.get('user.locale')
        var language = getLanguageFromLocale(locale)
        var organization = this.get('organization')
        var redirectUrl = absoluteRouteUrl(this.container, 'bank_sync', account.id)
        var countryId = organization.get('country.id')
        var url = '/banking/' + organization.get('id') + '/connect'

        var payload = {
            culture: language,
            preselectedCountry: countryId,
            redirectUrl: redirectUrl
        }

        return this.get('api').request('POST', url, { payload: payload, accept: 'application/json' }).then(
            function(data) {
                window.location.replace(data.authUrl)
            }
        )
    },

    connectBank: function(account) {
        var self = this

        if (!account) {
            trackError('No account specified for bank connection')
            return
        }

        self.setup(account)
    }
})
